import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaTimes } from 'react-icons/fa';
import ProtectedImage from '../components/ProtectedImage';

const Services = () => {
  const { t, i18n } = useTranslation();
  const [selectedService, setSelectedService] = useState(null);

  const services = [
    {
      image: '/assets/services/Bank Instrument.jpg',
      titleKey: 'services.page.bankInstrument.title',
      introKey: 'services.page.bankInstrument.intro',
      descriptionKey: 'services.page.bankInstrument.description',
      roleKey: 'services.page.bankInstrument.role',
      responsibilitiesKey: 'services.page.bankInstrument.responsibilities',
      instrumentsKey: 'services.page.bankInstrument.instruments',
      advantagesKey: 'services.page.bankInstrument.advantages',
      goalsKey: 'services.page.bankInstrument.goals',
      commitmentKey: 'services.page.bankInstrument.commitment'
    },
    {
      image: '/assets/services/Venture Capital Company.jpg',
      titleKey: 'services.page.ventureCapital.title',
      introKey: 'services.page.ventureCapital.intro',
      descriptionKey: 'services.page.ventureCapital.description',
      explanationKey: 'services.page.ventureCapital.explanation',
      differenceKey: 'services.page.ventureCapital.difference',
      supportKey: 'services.page.ventureCapital.support',
      commitmentKey: 'services.page.ventureCapital.commitment'
    },
    {
      image: '/assets/services/Holding Company Activities.jpg',
      titleKey: 'services.page.holding.title',
      introKey: 'services.page.holding.intro',
      descriptionKey: 'services.page.holding.description',
      explanationKey: 'services.page.holding.explanation',
      synergyKey: 'services.page.holding.synergy',
      positioningKey: 'services.page.holding.positioning'
    },
    {
      image: '/assets/services/Fintech Division.jpg',
      titleKey: 'services.page.fintech.title',
      introKey: 'services.page.fintech.intro',
      descriptionKey: 'services.page.fintech.description',
      explanationKey: 'services.page.fintech.explanation',
      paymentGatewayKey: 'services.page.fintech.paymentGateway',
      eWalletKey: 'services.page.fintech.eWallet',
      commitmentKey: 'services.page.fintech.commitment'
    },
    {
      image: '/assets/services/Crypto Exchanger & Blockchain Developers.jpg',
      titleKey: 'services.page.crypto.title',
      introKey: 'services.page.crypto.intro',
      descriptionKey: 'services.page.crypto.description',
      blockchainKey: 'services.page.crypto.blockchain',
      decentralizationKey: 'services.page.crypto.decentralization',
      smartContractsKey: 'services.page.crypto.smartContracts',
      commitmentKey: 'services.page.crypto.commitment'
    },
    {
      image: '/assets/services/Digital Platform & E-Commerce Development.jpg',
      titleKey: 'services.page.ecommerce.title',
      introKey: 'services.page.ecommerce.intro',
      descriptionKey: 'services.page.ecommerce.description',
      marketplaceKey: 'services.page.ecommerce.marketplace',
      advertisingKey: 'services.page.ecommerce.advertising',
      onDemandKey: 'services.page.ecommerce.onDemand',
      commitmentKey: 'services.page.ecommerce.commitment'
    },
    {
      image: '/assets/services/Physical Commodity Broker.jpg',
      titleKey: 'services.page.commodity.title',
      introKey: 'services.page.commodity.intro',
      descriptionKey: 'services.page.commodity.description',
      examplesKey: 'services.page.commodity.examples',
      hedgingKey: 'services.page.commodity.hedging',
      transparencyKey: 'services.page.commodity.transparency',
      commitmentKey: 'services.page.commodity.commitment'
    },
    {
      image: '/assets/services/Large-Scale Trade, Commodities & Energy Trading (Export & Import).jpg',
      titleKey: 'services.page.trading.title',
      introKey: 'services.page.trading.intro',
      descriptionKey: 'services.page.trading.description',
      focusKey: 'services.page.trading.focus',
      tradeFinanceKey: 'services.page.trading.tradeFinance',
      biofuelKey: 'services.page.trading.biofuel',
      commitmentKey: 'services.page.trading.commitment'
    },
    {
      image: '/assets/services/Travel Agency, Umrah & Pilgrimage Services.jpg',
      titleKey: 'services.page.travel.title',
      introKey: 'services.page.travel.intro',
      descriptionKey: 'services.page.travel.description',
      visionKey: 'services.page.travel.vision',
      servicesKey: 'services.page.travel.services',
      visaKey: 'services.page.travel.visa',
      commitmentKey: 'services.page.travel.commitment'
    }
  ];

  const openModal = (service) => {
    setSelectedService(service);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedService(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-maroon-900 to-maroon-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-4">
              {t('services.page.hero.title')}
            </h1>
            <p className="text-xl text-gray-100">
              {t('services.page.hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <p className="text-center text-xl text-gray-800 font-semibold">
            {t('services.page.intro')}
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              >
                {/* Service Image */}
                <div className="relative h-48 overflow-hidden">
                  <ProtectedImage
                    src={service.image}
                    alt={t(service.titleKey)}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>

                {/* Service Content */}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {t(service.titleKey)}
                  </h3>
                  
                  {/* View More Button */}
                  <button
                    onClick={() => openModal(service)}
                    className="w-full bg-gradient-to-r from-maroon-700 to-maroon-900 hover:from-maroon-800 hover:to-black-900 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-300 shadow-md hover:shadow-xl"
                  >
                    {i18n.language === 'id' ? 'Selengkapnya' : 'View More'}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal for Service Details */}
      {selectedService && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-maroon-900 to-maroon-700 text-white p-6 flex justify-between items-center">
              <h2 className="text-3xl font-bold">{t(selectedService.titleKey)}</h2>
              <button
                onClick={closeModal}
                className="text-white hover:text-gray-200 transition-colors duration-200"
              >
                <FaTimes className="text-2xl" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-8 overflow-y-auto max-h-[calc(90vh-100px)]">
              {/* Service Image in Modal */}
              <div className="mb-6 rounded-xl overflow-hidden">
                <ProtectedImage
                  src={selectedService.image}
                  alt={t(selectedService.titleKey)}
                  className="w-full h-64 object-cover"
                />
              </div>

              {/* Service Content */}
              <div className="space-y-4 text-gray-700 leading-relaxed">
                {selectedService.introKey && (
                  <p className="text-lg">{t(selectedService.introKey)}</p>
                )}
                
                {selectedService.descriptionKey && (
                  <p className="font-medium text-gray-900">{t(selectedService.descriptionKey)}</p>
                )}

                {selectedService.roleKey && (
                  <p>{t(selectedService.roleKey)}</p>
                )}

                {selectedService.responsibilitiesKey && (
                  <p className="bg-gray-50 p-4 rounded-lg">{t(selectedService.responsibilitiesKey)}</p>
                )}

                {selectedService.instrumentsKey && (
                  <p className="bg-gold-50 p-4 rounded-lg border-l-4 border-gold-600">{t(selectedService.instrumentsKey)}</p>
                )}

                {selectedService.advantagesKey && (
                  <p>{t(selectedService.advantagesKey)}</p>
                )}

                {selectedService.goalsKey && (
                  <p className="font-semibold text-maroon-800">{t(selectedService.goalsKey)}</p>
                )}

                {selectedService.explanationKey && (
                  <p>{t(selectedService.explanationKey)}</p>
                )}

                {selectedService.differenceKey && (
                  <p>{t(selectedService.differenceKey)}</p>
                )}

                {selectedService.supportKey && (
                  <p>{t(selectedService.supportKey)}</p>
                )}

                {selectedService.synergyKey && (
                  <p>{t(selectedService.synergyKey)}</p>
                )}

                {selectedService.positioningKey && (
                  <p>{t(selectedService.positioningKey)}</p>
                )}

                {selectedService.paymentGatewayKey && (
                  <p>{t(selectedService.paymentGatewayKey)}</p>
                )}

                {selectedService.eWalletKey && (
                  <p>{t(selectedService.eWalletKey)}</p>
                )}

                {selectedService.blockchainKey && (
                  <p>{t(selectedService.blockchainKey)}</p>
                )}

                {selectedService.decentralizationKey && (
                  <p>{t(selectedService.decentralizationKey)}</p>
                )}

                {selectedService.smartContractsKey && (
                  <p>{t(selectedService.smartContractsKey)}</p>
                )}

                {selectedService.marketplaceKey && (
                  <p>{t(selectedService.marketplaceKey)}</p>
                )}

                {selectedService.advertisingKey && (
                  <p>{t(selectedService.advertisingKey)}</p>
                )}

                {selectedService.onDemandKey && (
                  <p>{t(selectedService.onDemandKey)}</p>
                )}

                {selectedService.examplesKey && (
                  <p>{t(selectedService.examplesKey)}</p>
                )}

                {selectedService.hedgingKey && (
                  <p>{t(selectedService.hedgingKey)}</p>
                )}

                {selectedService.transparencyKey && (
                  <p>{t(selectedService.transparencyKey)}</p>
                )}

                {selectedService.focusKey && (
                  <p>{t(selectedService.focusKey)}</p>
                )}

                {selectedService.tradeFinanceKey && (
                  <p>{t(selectedService.tradeFinanceKey)}</p>
                )}

                {selectedService.biofuelKey && (
                  <p>{t(selectedService.biofuelKey)}</p>
                )}

                {selectedService.visionKey && (
                  <p>{t(selectedService.visionKey)}</p>
                )}

                {selectedService.servicesKey && (
                  <p>{t(selectedService.servicesKey)}</p>
                )}

                {selectedService.visaKey && (
                  <p>{t(selectedService.visaKey)}</p>
                )}

                {selectedService.commitmentKey && (
                  <div className="border-t border-gray-200 pt-4 mt-6">
                    <p className="text-sm italic text-maroon-800 font-semibold">
                      {t(selectedService.commitmentKey)}
                    </p>
                  </div>
                )}
              </div>

              {/* Close Button at Bottom */}
              <div className="mt-8 text-center">
                <button
                  onClick={closeModal}
                  className="bg-gradient-to-r from-maroon-700 to-maroon-900 hover:from-maroon-800 hover:to-black-900 text-white font-bold px-8 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
                >
                  {i18n.language === 'id' ? 'Tutup' : 'Close'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center bg-white rounded-2xl shadow-xl p-12">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4">
              {t('services.page.cta.title')}
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              {t('services.page.cta.subtitle')}
            </p>
            <a
              href="/contact"
              className="bg-gradient-to-r from-maroon-700 to-maroon-900 hover:from-maroon-800 hover:to-black-900 text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl inline-block"
            >
              {t('services.page.cta.button')}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
